import React from "react";
import { connect } from "react-redux";
import Traec from "traec";

const colors = {
  emcore: "FF3D00",
};

export function DynamicStyle(props) {
  let { navBarColor, headerColor, buttonColor } = props;

  console.log("LOADED COLORS FROM STYLE", props);

  // Default colors - use #1a2332 for both navbar and sidebar for consistency
  const defaultNavBarColor = "#1a2332";
  const defaultHeaderColor = "#1a2332";

  // For testing only
  //headerColor = "#FF6100";
  //buttonColor = "#FF8500";
  //navBarColor = "#666666";

  let text = "";

  // Always set sidebar color (use custom or default)
  const sidebarColor = headerColor || defaultHeaderColor;
  text += `
.page-sidebar { background-color: ${sidebarColor}; }
.footer { background-color: ${sidebarColor}; }
.card-header { background-color: ${sidebarColor}; }
`;

  if (buttonColor) {
    text += `
.btn-primary { background-color: ${buttonColor}; border-color: ${buttonColor} }
.btn-primary:disabled { background-color: ${buttonColor}; border-color: ${buttonColor} }
`;
  }

  // Always set navbar color (use custom or default)
  const navColor = navBarColor || defaultNavBarColor;
  text += `
.navbar-light { background-color: ${navColor} !important; }
`;

  if (!text) {
    return null;
  }

  return <style>{text}</style>;
}

const mapStateToProps = (state, ownProps) => {
  let styles = state.getInPath("ui.styles") || Traec.Im.Map();
  let _props = ["navBarColor", "headerColor", "buttonColor"].reduce((acc, cur) => {
    acc[cur] = styles.get(cur);
    return acc;
  }, {});
  return { ..._props };
};

export default connect(mapStateToProps)(DynamicStyle);
